export default __webpack_public_path__ + "static/web-76d1e3fa0cbd2d65bb9fc485e5c76cb6.svg";